<app-manage-shipments-component [archivedMode]="true"></app-manage-shipments-component>
